/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { adminOpenRouterKeysEnableKey } from "../funcs/adminOpenRouterKeysEnableKey.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AdminOpenRouterKey } from "../models/components/adminopenrouterkey.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  EnableAdminOpenRouterKeyRequest,
  EnableAdminOpenRouterKeySecurity,
} from "../models/operations/enableadminopenrouterkey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type EnableAdminOpenRouterKeyMutationVariables = {
  request: EnableAdminOpenRouterKeyRequest;
  security?: EnableAdminOpenRouterKeySecurity | undefined;
  options?: RequestOptions;
};

export type EnableAdminOpenRouterKeyMutationData = AdminOpenRouterKey;

export type EnableAdminOpenRouterKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * enableKey adminOpenRouterKeys
 *
 * @remarks
 * Reinstate a disabled platform OpenRouter key, upstream and locally, keeping its recorded credit ceiling. Requires platform admin.
 */
export function useEnableAdminOpenRouterKeyMutation(
  options?: MutationHookOptions<
    EnableAdminOpenRouterKeyMutationData,
    EnableAdminOpenRouterKeyMutationError,
    EnableAdminOpenRouterKeyMutationVariables
  >,
): UseMutationResult<
  EnableAdminOpenRouterKeyMutationData,
  EnableAdminOpenRouterKeyMutationError,
  EnableAdminOpenRouterKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildEnableAdminOpenRouterKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyEnableAdminOpenRouterKey(): MutationKey {
  return ["@gram/client", "adminOpenRouterKeys", "enableKey"];
}

export function buildEnableAdminOpenRouterKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: EnableAdminOpenRouterKeyMutationVariables,
  ) => Promise<EnableAdminOpenRouterKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyEnableAdminOpenRouterKey(),
    mutationFn: function enableAdminOpenRouterKeyMutationFn({
      request,
      security,
      options,
    }): Promise<EnableAdminOpenRouterKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(adminOpenRouterKeysEnableKey(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
